const ItemType = require('@/lib/Items/ItemType');
const { getItemTypeTabLangKey } = require('@/lib/Items/itemTypeTabs');
const { populate } = require('@/functions/objects');

/**
 * @constructor
 *
 * @param {{}} data
 */
const OrderItemGroup = function (data) {
    /**
     * @type {string}
     */
    this.ID = undefined;

    /**
     * @type {string}
     */
    this.itemType = undefined;

    /**
     * @type {OrderLine[]}
     */
    this.items = [];

    /**
     * @type {Session|null}
     */
    this.session = null;

    /**
     * @type {boolean}
     */
    this.isDifferentTimezone = false;

    /**
     * @type {BookingGroup|null}
     */
    this.bookingGroup = null;

    populate(this, data);
};

OrderItemGroup.prototype = {
    /**
     * @returns {string}
     */
    getNameLangKey() {
        if (this.itemType === ItemType.TICKET && !this.session) {
            // Open tickets get their own line (in the summary) or group within Tickets tab.
            // Even though OPEN_TICKET isn't really a tab this keeps things neat.
            return 'ITEMS_TAB_NAME.OPEN_TICKET';
        }

        // For every other item type the group heading is the same as the tab label.
        return getItemTypeTabLangKey(this.itemType);
    },

    getRenewingMemberships() {
        // Return an array of any membership that the user wishes to renew.
        // This method looks at all the items in this group that are memberships (and the observant among you
        // will note that either all the items are memberships, or none of them are), and return any that
        // user has chosen to renew.
        let result = [];
        for (let itemIndex = 0; itemIndex < this.items.length; itemIndex++) {
            let orderLine = this.items[itemIndex];
            if (orderLine.item && orderLine.item.itemType === ItemType.MEMBERSHIP_PLAN) {
                for (let instanceIndex = 0; instanceIndex < orderLine.iteminstances.length; instanceIndex++) {
                    let itemInstance = orderLine.iteminstances[instanceIndex];
                    if (itemInstance.membership && itemInstance.membership.isRenewing()) {
                        result.push(itemInstance.membership);
                    }
                }
            }
        }

        return result;
    },

    anyRenewingMemberships() {
        // Return true if the user is renewing one or more membership; false otherwise.
        return this.getRenewingMemberships().length > 0;
    },

    clearMembershipRenewing() {
        // Go through all memberships in this group, and make sure they are not renewing.
        for (let itemIndex = 0; itemIndex < this.items.length; itemIndex++) {
            let orderLine = this.items[itemIndex];
            if (orderLine.item.itemType !== 'Membership Plan') {
                continue;
            }
            for (let instanceIndex = 0; instanceIndex < orderLine.iteminstances.length; instanceIndex++) {
                if (orderLine.iteminstances[instanceIndex].membership) {
                    orderLine.iteminstances[instanceIndex].membership.resetRenew();
                }
            }
        }
    },

    isRedemptionPossible() {
        return this.itemType === 'Ticket' || this.itemType === 'Membership Plan';
    },
};

module.exports = OrderItemGroup;
